import React, { useState, useRef } from "react";
import "../styles/Buttons.css";
import "../styles/Colors.css";
import "../styles/Containers.css";
import { baseURL } from "../custom/api";
import { Link } from "react-router-dom";

export default function Card({ card }) {
  const frontEl = useRef();

  return (
    <div className="card">
      <Link to={`/recipe/${card.recipe_id}`} className="front" ref={frontEl}>
        {card.active_status !== "active" ? (
          // UI to render when endpoint data is not null
          <div>
            <div>
              <span className="icon-iconbag2 z-index1-center heading-1 round grey-1"></span>
              <img
                src={`${baseURL}/${card.image_path}`}
                alt={card.recipe_name}
                className="radius2"
              />{" "}
            </div>
            {/* This is picture */}
            <div className="text-box">
              <div>
                {card.recipe_name} {/* This is foodName */}
              </div>
              <div className="s-1">
                {card.cooking_duration}
                {/* This is cookTime */} دقیقه
              </div>
            </div>
          </div>
        ) : (
          // UI to render when endpoint data is null
          <div>
            <img
              src={`${baseURL}/${card.image_path}`}
              alt={card.recipe_name}
              className="radius2"
            />{" "}
            {/* This is picture */}
            <div className="text-box">
              <div>
                {card.recipe_name} {/* This is foodName */}
              </div>
              <div className="s-1">
                {card.cooking_duration}
                {/* This is cookTime */} دقیقه
              </div>
            </div>
          </div>
        )}
      </Link>
    </div>
  );
}
